<template>
  <div class="wrapper">
    <lastpage></lastpage>
    <div class="brief_introduction">
      <div>
        <img src="@/assets/appointment/doctor_icon.png" />
        <div>
          <p>{{ doctorInfo.DoctorName }}</p>
          <p>{{ doctorInfo.DeptName }}/{{ doctorInfo.LabelName }}</p>
        </div>
      </div>
      <div>
        <span>擅长：{{ zsdata }}</span>
        <!-- 事件：展开 / 收起「擅长」全文 -->
        <img :src="bg_url" @click="showtext" v-if="textOver" />
      </div>
    </div>
    <ul class="timeSel">
      <!-- 事件：切换就诊日期，并重新请求该日号源 -->
      <li
        v-for="(item, index) in date"
        :key="index"
        @click="handleTab(index, item)"
        :class="current === index ? 'list_xuan' : ''"
      >
        <span>{{ item.week }}</span>
        <span>{{ item.day }}</span>
        <span :class="current === index ? 'selectTriangle' : ''"></span>
      </li>
    </ul>
    <ul v-if="showDuty" class="dataSel">
      <li class="title">{{ doctorInfo.DeptName }}</li>
      <li v-if="timeList.morning.list.length">
        <span>上午</span>
        <span
          >挂号费：￥{{
            refRecordData.resultData ? "0.00" : doctorInfo.Fee
          }}</span
        >
        <!-- 事件：打开「上午」具体时段弹窗 -->
        <span @click="btnSel(1)"
          >余号：{{ timeList.morning.AllRegRemained }}</span
        >
      </li>
      <li v-if="timeList.afternoon.list.length">
        <span>下午</span>
        <span
          >挂号费：￥{{
            refRecordData.resultData ? "0.00" : doctorInfo.Fee
          }}</span
        >
        <!-- 事件：打开「下午」具体时段弹窗 -->
        <span @click="btnSel(2)"
          >余号：{{ timeList.afternoon.AllRegRemained }}</span
        >
      </li>
      <li v-if="timeList.night.list.length">
        <span>晚上</span>
        <span
          >挂号费：￥{{
            refRecordData.resultData ? "0.00" : doctorInfo.Fee
          }}</span
        >
        <!-- 事件：打开「晚上」具体时段弹窗 -->
        <span @click="btnSel(3)"
          >余号：{{ timeList.night.AllRegRemained }}</span
        >
      </li>
    </ul>
    <!-- 事件：v-model 控制弹窗显隐；列表项 click 见 datebtn -->
    <van-popup v-model="periodPopup.show" round position="bottom">
      <div class="title_top">
        {{ nowdate.replace(/\./g, "月") }}日 {{ today }} {{ periodPopup.wu }}
      </div>
      <ul class="time_list">
        <!-- 事件：选中号源时段，跳转预约详情 -->
        <li
          v-for="(item, index) in periodPopup.list"
          :key="item.TimeId != null ? item.TimeId : index"
          @click="datebtn(item)"
        >
          <span>{{ item.TimeDesc }}</span>
          <span>余号:{{ item.RegRemained }}</span>
        </li>
      </ul>
    </van-popup>
    <div v-if="!showDuty" class="null_doctor">
      当日暂无值班
    </div>
  </div>
</template>

<script>
import { getDoctorScheduleTime } from "@/request/api.js";
import upper from "@/assets/appointment/jts_icon.png";
import lower from "@/assets/appointment/jtx_icon.png";
import lastpage from "@/components/lastpage/lastpage.vue";

const USER_ID = "7148";
const WEEK_EN_SHORT = {
  Monday: "周一",
  Tuesday: "周二",
  Wednesday: "周三",
  Thursday: "周四",
  Friday: "周五",
  Saturday: "周六",
  Sunday: "周日"
};
const WEEK_EN_LONG = {
  Monday: "星期一",
  Tuesday: "星期二",
  Wednesday: "星期三",
  Thursday: "星期四",
  Friday: "星期五",
  Saturday: "星期六",
  Sunday: "星期日"
};
const DAY_LABELS = [
  "星期日",
  "星期一",
  "星期二",
  "星期三",
  "星期四",
  "星期五",
  "星期六"
];
const PERIOD_KEYS = {
  上午: "morning",
  下午: "afternoon",
  晚上: "night"
};
const BTN_PERIOD = {
  1: { key: "morning", wu: "上午" },
  2: { key: "afternoon", wu: "下午" },
  3: { key: "night", wu: "晚上" }
};

function apiObj(res) {
  return ((res || {}).data || {}).obj || {};
}

function emptyTimeList() {
  return {
    morning: { list: [], AllRegRemained: 0 },
    afternoon: { list: [], AllRegRemained: 0 },
    night: { list: [], AllRegRemained: 0 }
  };
}

export default {
  components: {
    lastpage
  },
  data() {
    return {
      refRecordData: JSON.parse(sessionStorage.getItem("refRecordData")),
      current: 0,
      bg_url: lower,
      textOver: false,
      advantages: "",
      zsdata: "",
      doctorInfo: {},
      nowdate: null,
      today: null,
      year: null,
      date: [],
      timeList: emptyTimeList(),
      showDuty: false,
      hspCode: sessionStorage.getItem("hspCode"),
      periodPopup: {
        show: false,
        list: [],
        wu: "上午"
      }
    };
  },
  // 生命周期：初始化医生信息、日历、就诊日、号源与选中日期索引
  created() {
    try {
      this.doctorInfo = JSON.parse(
        sessionStorage.getItem("doctorInfo") || "{}"
      );
    } catch (e) {
      this.doctorInfo = {};
    }
    this.advantages = this.doctorInfo.Description
      ? this.doctorInfo.Description
      : "信息正在录入中...";
    this.getDate();
    this.textellipsis();
    let clinicDate = sessionStorage.getItem("clinicDate");
    if (!clinicDate) {
      clinicDate = this.$moment().format("YYYY-MM-DD");
      sessionStorage.setItem("clinicDate", clinicDate);
    }
    this.today = this.getWeek(clinicDate);
    this.nowdate = clinicDate.slice(5, 10).replace(/-/g, ".");
    this.getTime(clinicDate);
    const saved = sessionStorage.getItem("current");
    const idx = saved !== null && saved !== "" ? parseInt(saved, 10) : 0;
    this.current = Number.isNaN(idx) ? 0 : idx;
  },
  // 生命周期：从缓存返回时刷新当前日号源
  activated() {
    this.getTime();
  },
  methods: {
    /** 由就诊日字符串解析星期（用于弹窗标题等） */
    getWeek(clinicDate) {
      const d = this.$moment((clinicDate || "").replace(/-/g, "/")).day();
      return DAY_LABELS[d] || "";
    },
    /** 生成顶部横向 7 天日期数据 */
    getDate() {
      this.year = this.$moment().format("YYYY");
      this.date = [];
      for (let i = 0; i < 7; i++) {
        const str = this.$moment()
          .add(i, "days")
          .format("dddd,M.DD");
        const [enWeek, dayPart] = str.split(",");
        const today = WEEK_EN_LONG[enWeek] || "";
        const week = i === 0 ? "今天" : WEEK_EN_SHORT[enWeek] || "";
        this.date.push({ week, day: dayPart, today });
      }
      if (!this.nowdate) {
        this.nowdate = this.date[0].day;
        this.today = this.date[0].today;
      }
    },
    /** 请求医生在指定日期的分时段号源；无参时用当前选中日期 */
    async getTime(time) {
      const date =
        time === undefined || time === null
          ? (this.year + "." + this.nowdate).replace(/\./g, "-")
          : time;
      sessionStorage.setItem("clinicDate", date);
      const map = {
        clinicDate: this.$moment(date.replace(/-/g, "/")).format("YYYY-MM-DD"),
        deptID: this.doctorInfo.DeptID,
        doctorId: this.doctorInfo.DoctorId,
        hspCode: this.hspCode,
        userId: USER_ID,
        workType: this.doctorInfo.workType
      };
      try {
        const res = await getDoctorScheduleTime(map);
        const ok = res.data && res.data.message === "操作成功";
        if (!ok) {
          this.showDuty = false;
          this.timeList = emptyTimeList();
          return;
        }
        const rows = apiObj(res).resultData || [];
        const next = emptyTimeList();
        rows.forEach(item => {
          const parts = (item.TimeDesc || "").split(" ");
          const period = parts[0];
          const key = PERIOD_KEYS[period];
          if (!key || !parts[1]) return;
          const bucket = next[key];
          bucket.AllRegRemained += item.RegRemained;
          bucket.list.push({
            TimeId: item.TimeId,
            TimeDesc: parts[1].replace(/-/g, "~"),
            RegRemained: item.RegRemained,
            resultData: item
          });
        });
        this.timeList = next;
        this.showDuty = true;
      } catch (e) {
        this.showDuty = false;
        this.timeList = emptyTimeList();
      }
    },
    /** 事件：点击日期 tab — 更新选中态与星期文案并拉号源 */
    handleTab(index, item) {
      this.current = index;
      this.nowdate = item.day;
      this.today = item.today;
      this.getTime();
    },
    /** 擅长文案过长时截断并显示展开入口 */
    textellipsis() {
      if (this.advantages.length > 38) {
        this.textOver = true;
        this.zsdata = this.advantages.substring(0, 38) + "...";
      } else {
        this.zsdata = this.advantages;
      }
    },
    /** 事件：点击箭头 — 展开 / 收起擅长全文 */
    showtext() {
      if (this.bg_url === lower) {
        this.bg_url = upper;
        this.zsdata = this.advantages;
      } else {
        this.bg_url = lower;
        this.zsdata = this.advantages.substring(0, 38) + "...";
      }
    },
    /** 事件：点击余号 — num: 1上午 2下午 3晚上，打开对应时段弹窗并写入 timeData2 */
    btnSel(num) {
      const cfg = BTN_PERIOD[num];
      if (!cfg) return;
      const list = this.timeList[cfg.key].list;
      this.periodPopup = {
        show: true,
        list,
        wu: cfg.wu
      };
      sessionStorage.setItem(
        "timeData2",
        JSON.stringify({ today: this.today, wu: cfg.wu })
      );
    },
    /** 事件：点击弹窗内时段 — 写入 timeData 与 current，跳转预约详情 */
    datebtn(item) {
      sessionStorage.setItem("current", this.current);
      sessionStorage.setItem("timeData", JSON.stringify(item.resultData));
      this.$router.push("/AppointmentDetails");
    }
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #f8f8f8;
  .van-popup {
    .title_top {
      font-size: 17px;
      font-weight: bold;
      line-height: 45px;
      background: #1c96cb;
      text-align: center;
      color: #fff;
    }
    .time_list {
      padding: 6px 19px 48px;
      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;
      > li {
        display: flex;
        flex-flow: column nowrap;
        margin-top: 14px;
        width: 106px;
        height: 53px;
        background: #ddeff6;
        font-size: 12px;
        color: #1c96cb;
        justify-content: center;
        align-items: center;
      }
    }
  }
  .brief_introduction {
    letter-spacing: 1px;
    color: #fff;
    // margin-top: 10px;
    padding: 21px 17px 21px 19px;
    background: linear-gradient(180deg, #5bb3d9 0%, #1c96cb 100%);
    > div:nth-child(1) {
      display: flex;
      flex-flow: row nowrap;
      > img {
        width: 38px;
        height: 46px;
      }
      > div {
        margin-left: 16px;
        font-size: 13px;
        > p:nth-child(1) {
          margin: 3px 0px 3px;
          font-size: 17px;
          font-weight: bold;
        }
      }
    }
    > div:nth-child(2) {
      position: relative;
      margin-top: 19px;
      font-size: 12px;
      > img {
        position: absolute;
        right: 12px;
        bottom: 0px;
        width: 12px;
        height: 8px;
      }
    }
  }
  .timeSel {
    display: flex;
    flex-flow: row nowrap;
    margin-top: 10px;
    background: #fff;
    height: 78px;
    font-size: 15px;
    > li {
      position: relative;
      flex: 1;
      display: flex;
      flex-flow: column nowrap;
      text-align: center;
      height: 100%;
      justify-content: center;
      > span:nth-child(1) {
        margin-bottom: 13px;
      }
      .selectTriangle {
        transition: all 0.6s;
        position: absolute;
        width: 32px;
        height: 5px;
        left: calc(50% - 16px);
        bottom: 2px;
        background: #1c96cb;
        border-radius: 3px;
        margin: 0px !important;
      }
    }
    .list_xuan {
      transition: all 0.6s;
      color: #1c96cb;
    }
  }
  .dataSel {
    margin-top: 14px;
    background: #fff;
    > li {
      display: flex;
      flex-flow: row nowrap;
      padding: 13px 14px;
      border-bottom: 1px solid #dfdfdf;
      color: #707070;
      align-items: center;
      > span:nth-child(1) {
        margin-right: 40px;
      }
      > span:nth-child(2) {
        flex: 1;
      }
      > span:nth-child(3) {
        padding: 7px 11px;
        background: #1c96cb;
        border-radius: 19px;
        color: #fff;
      }
    }
    .title {
      font-size: 15px;
      font-weight: bold;
      color: #000;
    }
  }
  .null_doctor {
    text-align: center;
    padding: 60px 0px;
    font-size: 20px;
    font-weight: bold;
    color: #999;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Index/ChooseTime.vue